import { getStore } from '../store';

/**
 * Obtiene las credenciales de Basic Auth ya codificadas en base64
 * Primero intenta obtenerlas del Redux store, si no existen las recupera del API
 * @param {string} user - Usuario (ej: "E1656603")
 * @param {string} mailAccount - Email de la cuenta (ej: "lsp46@gmx.es")
 * @param {string} token - Token de autorización (lexonToken)
 * @returns {Promise<string>} String base64 para Basic Auth
 */
export const getBasicAuthCredentials = async (user, mailAccount, token) => {
  const store = getStore();
  let basicAuthToken = store.getState().lexon.nextcloudAccountAuth;

  // Si ya existe en Redux, devolverlo directamente
  if (basicAuthToken) {
    return basicAuthToken;
  }

  // Si no existe, llamar al API
  const url = `${window.URL_GET_ACCOUNTS}/${user}/accountnx/${encodeURIComponent(mailAccount)}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'text/plain',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to get credentials: ${response.status}`);
  }

  const result = await response.json();

  if (result.errors && result.errors.length > 0) {
    throw new Error(`Error getting credentials: ${result.errors[0]}`);
  }

  basicAuthToken = result.data;

  // Guardar en Redux para futuras llamadas
  store.dispatch({ type: 'NEXTCLOUD_ACCOUNT_AUTH', payload: basicAuthToken });

  return basicAuthToken;
};
